// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

import { PlayerActionStatusEnum, type TreatmentCard } from '../../types/game';
import { Button } from '../Button';
import { TreatmentCardList } from '../TreatmentCard';

interface PlayerSubmissionSectionProps {
  yourHand: TreatmentCard[];
  selectedCardIndices: number[];
  onCardClick: (index: number) => void;
  onSubmitCards: () => void;
  submitting: boolean;
  myActionStatus: PlayerActionStatusEnum | string;
}

export function PlayerSubmissionSection({
  yourHand,
  selectedCardIndices,
  onCardClick,
  onSubmitCards,
  submitting,
  myActionStatus,
}: PlayerSubmissionSectionProps) {
  return (
    <div className="glass rounded-lg p-4 sm:p-6 mb-6" data-testid="game-player-submission-section">
      <h2 className="font-display text-xl sm:text-2xl font-bold mb-3 sm:mb-4">
        Your Treatments - Select Cards to Submit
      </h2>
      <TreatmentCardList
        cards={yourHand}
        selectedIndices={selectedCardIndices}
        onCardClick={onCardClick}
      />
      <div className="mt-3 sm:mt-4">
        <Button
          variant="success"
          onClick={onSubmitCards}
          disabled={
            selectedCardIndices.length === 0 ||
            submitting ||
            myActionStatus === PlayerActionStatusEnum.ACTION_TAKEN
          }
          className="w-full py-2 sm:py-3 min-h-10 sm:min-h-12"
          data-testid="game-submit-cards-button"
        >
          {submitting
            ? 'Submitting...'
            : myActionStatus === PlayerActionStatusEnum.ACTION_TAKEN
              ? 'Submitted!'
              : `Submit ${selectedCardIndices.length} Card(s)`}
        </Button>
      </div>
    </div>
  );
}
